// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ss-9";
export var arrowButtonContainer = "_ss-5";
export var arrowButtonIcon = "_ss-6";
export var carouselArrowButton = "_ss-2";
export var carouselElementContainer = "_ss-1";
export var currentSlide = "_ss-8";
export var left = "_ss-3";
export var otherSlide = "_ss-a";
export var productCarouselContainer = "_ss-0";
export var right = "_ss-4";
export var sliderOverflow = "_ss-7";